import React, { useEffect } from "react";
import useTestProgress from "../../hooks/dte/useTestProgress";
import useCertificateDownload from "../../hooks/pdf/useCertificateDownload";

const CertificateDownloadCard: React.FC = () => {
  const { completed, fetchCompleted } = useTestProgress();
  const { handleDownloadCertificate } = useCertificateDownload();

  useEffect(() => {
    fetchCompleted();
  }, []);

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="border-b border-stroke px-4 py-4 dark:border-strokedark sm:px-6 xl:px-7.5">
        <h3 className="font-medium text-black dark:text-white">
          Certificado de Culminación
        </h3>
      </div>

      <div className="p-6 flex flex-col items-center text-center gap-4">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Este certificado se habilitará automáticamente cuando todas las pruebas hayan sido completadas.
        </p>

        <button
          onClick={handleDownloadCertificate}
          disabled={!completed}
          className={`inline-flex rounded py-2 px-4 text-sm font-medium transition ${
            completed
              ? "bg-primary text-white hover:bg-primary/90"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          Descargar Certificado PDF
        </button>
      </div>
    </div>
  );
};

export default CertificateDownloadCard;
